import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { tomos, tomoIncludes } from '../../data/content';
export function Tomos() {
  return <section className="py-20 relative" data-id="element-289" data-mp="7xcp01stbq9t">
      <div className="container mx-auto px-4" data-id="element-290" data-mp="7ydy40q9q2ow">
        <div className="text-center mb-16" data-id="element-291" data-mp="cw61ps09zd8x">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-ink flex items-center justify-center gap-3" data-id="element-292" data-mp="cuuney97en3k">
            <span aria-hidden="true" data-id="element-293" data-mp="3bfmf6id68yik">📚</span> LOS 6 TOMOS DEL SISTEMA
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-20" data-id="element-294" data-mp="3gd4r8hmhjtus">
          {tomos.map((tomo, index) => <motion.article key={tomo.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-2xl bg-surface border border-line hover:border-pistachio-400 transition-colors group" data-id="element-295" data-mp="3qasphhjavjhp" data-mpi={index}>
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" aria-hidden="true" data-id="element-296" data-mp="1ctnzxvved2oa">
                {tomo.emoji}
              </div>
              <h3 className="text-xl font-bold text-ink mb-1" data-id="element-297" data-mp="13t99yj7hmzeg">{tomo.title}</h3>
              <p className="text-sm font-medium text-pistachio-700 mb-4" data-id="element-298" data-mp="13vbxmwl64gg0">{tomo.subtitle}</p>
              <p className="text-muted leading-relaxed text-sm" data-id="element-299" data-mp="yvr10sth0k6g">{tomo.desc}</p>
            </motion.article>)}
        </div>

        <div className="max-w-3xl mx-auto p-8 md:p-10 rounded-3xl bg-pistachio-100 border border-pistachio-200" data-id="element-300" data-mp="p3lc5ryimivh">
          <h3 className="text-2xl font-display font-bold text-ink mb-8 text-center" data-id="element-301" data-mp="l3aw1mh0ec2w">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-302" data-mp="g2n4mzovbt85">
            {tomoIncludes.map((item, index) => <motion.div key={item} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-start gap-3" data-id="element-303" data-mp="b6o9mt91bcyr" data-mpi={index}>
                <CheckCircle2Icon className="w-5 h-5 text-pistachio-600 shrink-0 mt-0.5" aria-hidden="true" data-id="element-304" data-mp="3sn0ztz9ny4gq" />
                <span className="text-ink/80 text-sm leading-tight pt-0.5" data-id="element-305" data-mp="k7zdqrx70kod">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}